
export const EnumStatusFastRental = {
  Pendente: 1,
  EmAnalise: 2,
  Rejeitado: 3,
  Habilitado: 4
};


export class Usuario {
  id_usuarios: number;
  nome: string;
  email: string;
  celular: string;
  data_nascimento: Date;
  administrador: boolean;
  sexo: number;
}
